import User from "@/modules/account/user.model";

export default class LoginRedirectResolverService {
  public async calculateUrl(user: User): Promise<string> {
    return Promise.resolve("/");
  }
}
